import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class MultipleDomains extends Entity<MultipleDomains> {
    @Expose({ name: 'show_domain_chooser' })
    enabled!: boolean
}
